import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CelebrationIcon from '@mui/icons-material/Celebration';

/**
 * Thank you card displayed when the interview is complete.
 */
const ThankYouCard = ({ surveyInfo, completionMessage }) => {
  return (
    <Card
      sx={{
        maxWidth: 600,
        mx: 'auto',
        mt: 4,
        borderRadius: 4,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        overflow: 'hidden'
      }}
    >
      {/* Celebration header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
          color: 'white',
          p: 5,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Decorative circles */}
        <Box
          sx={{
            position: 'absolute',
            top: -20,
            left: -20,
            width: 100,
            height: 100,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.1)'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -30,
            right: -30,
            width: 120,
            height: 120,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.1)'
          }}
        />

        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 2 }}>
            <CelebrationIcon sx={{ fontSize: 40 }} />
            <CheckCircleIcon sx={{ fontSize: 48 }} />
            <CelebrationIcon sx={{ fontSize: 40 }} />
          </Box>

          <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
            Interview Complete!
          </Typography>

          <Typography variant="h6" sx={{ opacity: 0.95 }}>
            Thank you for your time and insights
          </Typography>
        </Box>
      </Box>

      <CardContent sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 3,
            fontSize: '1.1rem',
            lineHeight: 1.7,
            maxWidth: 450,
            mx: 'auto'
          }}
        >
          {completionMessage || surveyInfo?.completion_message ||
            'Your feedback is incredibly valuable to us. The insights you\'ve shared will help us build better solutions for property managers like you.'}
        </Typography>

        <Box
          sx={{
            bgcolor: 'grey.50',
            borderRadius: 3,
            p: 3,
            mb: 3
          }}
        >
          <Typography variant="subtitle2" color="primary" gutterBottom>
            What happens next?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Our team will analyze your responses along with other participants' feedback
            to identify patterns and opportunities for improvement.
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          If you have any additional thoughts, feel free to reach out to our team.
        </Typography>

        <Button
          variant="outlined"
          onClick={() => window.close()}
          sx={{
            borderRadius: 2,
            px: 4
          }}
        >
          Close Window
        </Button>
      </CardContent>

      {/* Nivasa.ai branding */}
      <Box
        sx={{
          bgcolor: 'grey.100',
          py: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Powered by{' '}
          <Box
            component="span"
            sx={{
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            Nivasa.ai
          </Box>
        </Typography>
      </Box>
    </Card>
  );
};

export default ThankYouCard;
